import { render, staticRenderFns } from "./view-student.vue?vue&type=template&id=27c95d8f"
import script from "./view-student.vue?vue&type=script&lang=js"
export * from "./view-student.vue?vue&type=script&lang=js"
import style0 from "./view-student.vue?vue&type=style&index=0&id=27c95d8f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports